import { render, staticRenderFns } from "./AgreementDetail.vue?vue&type=template&id=cf633cea"
import script from "./AgreementDetail.vue?vue&type=script&lang=js"
export * from "./AgreementDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports